import React, { memo, useEffect, useState, StrictMode , useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import logo from "../../../Assets/Images/logo.png";
import PDFTransaction from "../PDFComponents/PDFTransaction";
import { SpanMessage } from "../../../helpers/componentHelper";
import { transactionSeperation , getUserLogo } from "../../../helpers/dataHelper";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { Config } from "../../../Utils/Config";
import { encryptPayload } from "../../../Utils/crypto_utils";

const DownloadReportTransactions = memo((props) => {
  const [marketSummary, setMarketSummary] = useState({});
  const { id, key } = useParams();
  const navigate = useNavigate();
  const [address, setAddress] = useState("");
  const [marketInfo, setMarketInfo] = useState({});
  const [transactionData, setTransactionData] = useState([]);
  const [transNoData, setransNodata] = useState(false);
  const [showUserLogo, setShowUserLogo] = useState(null);
  const displayLogoRef = useRef(logo);

  useEffect(() => {
    getLogo();
    getReportDetails();
    getTransactionsDetails();
  }, []);

  const getLogo = async () => {
    const logoData = await getUserLogo(key , logo);
    setShowUserLogo(logoData);
    displayLogoRef.current = logoData || logo;
  }

  //get report info
  const getReportDetails = () => {
      let inputData={ id,
              marketid: !parseInt(id) ? null : parseInt(id),
        securitykey: !key ? null : key.toString(),}
        apiCommonTrigger("post",`${Config.API_URL}/markets/market/report/summarydata`,inputData)
   .then((res) => {
      if (res.status === 200) {
        let marketDetails = res.data.marketdata;
        let addressLine = marketDetails.streetaddress1
          ? marketDetails.streetaddress1
          : "";
        let fmtAddress = marketDetails.profileid
          ? addressLine + ", "
          : addressLine;
        let city = marketDetails.city ? marketDetails.city + ", " : "";
        let state = marketDetails.statecode ? marketDetails.statecode : "";
        let country = marketDetails.countryname
          ? " " + marketDetails.countryname
          : "";
        setMarketSummary({ ...marketSummary, marketSummary: res.data });
        setAddress(fmtAddress + city + state + country);
        setMarketInfo(marketDetails);
      }else{
        handlingCatchError(res, navigate);
      } 
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  //get Development info
  const getTransactionsDetails = () => {
  let url=`/KnownDev/salestransaction/`;
  apiCommonTrigger("get",Config.API_URL+url,[id])
 .then((response) => {
      if (response.status === 200) {             
        const transactionResult = transactionSeperation(response);
        setTransactionData(transactionResult.transFormatData);
        setransNodata(transactionResult.transNoData);
      }else{
        handlingCatchError(response, navigate);
      } 
    })
    .catch(err => {
      handlingCatchError(err, navigate);
    })
  };

  const displayKnownDev = () => {
    let transData = transNoData ? [{}] : transactionData;
    let pageCount = 0;
    let list = [];
    list.push (
      <>
        {transData.map((strData, dt) => {
          return(
          <div className={!showUserLogo ? "print-pdf detail-pdf" : "print-pdf detail-pdf with_client_logo" }>
          <section className="pdf-wid-wrapper">
            <header className="page-header">
                <div className="page-logo">
                  <a href="#">
                    <img src={displayLogoRef.current} alt="RVParkIQ" />
                  </a>
                </div>
                <div className="header-address">
                  <p>{address}</p>
                </div>
                <div className="clear"></div>
              </header>
              <div className="page-number">Page No: {dt + 1}</div>
              <div className="page-body">
              {dt === 0 &&<div>
                <h4 className="pdf-title">Market Summary</h4>
                <p style={{marginBottom: '5px'}}><b>Market:</b> {marketInfo?.marketname || "N/A"}</p>
                <p><b>Market Type:</b> {marketInfo.supplyradius ? marketInfo.supplyradius + " miles around " + address : ""}</p>
                <div>
                  <h4 className="pdf-title">Transactions</h4>
                  <p>Sales transactions occurred from 2019 - till date on the facilities in the market. Each transaction profile includes information such as Sale Price, Date Listed, Date Sold, Deed Information, Deed Type etc.</p>
                </div>
              </div>}
              <section>
                  <div className="marg-top">
                    <div className="wrapper-report">
                      <span>
                        {dt !== 0 && 
                        <>
                        <h4 className="pdf-title continue">Transactions</h4>
                        Continued</>}
                      </span>
                      <div className="col-lg-12 marg-bot p-0">
                        <StrictMode>
                        {!transNoData ?
                              strData.map(strFormatData =>
                                <PDFTransaction
                                  storeDetails={strFormatData.storeDetails}
                                  transactionData={strFormatData.data}
                                  transactionAttrData={strFormatData.attrData}
                                />)
                              : SpanMessage("transactions") }
                        </StrictMode>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <footer className="page-footer">
                <div>
                  Copyright ©{(new Date().getFullYear())} StorTrack, Inc. All Rights Reserved.
                </div>
              </footer>
              <div id="pbreak" className="page-break" />
            </section>
          </div>
        )})}
      </>
    );
    return list;
  }

  return (
    <React.Fragment>
      {transactionData ? displayKnownDev() : 'Please Wait for data'}
    </React.Fragment>
  );
});

export default DownloadReportTransactions;
